/* Memorial · directorio de velatorios/parroquias por distrito: acordeón + buscador (no cambia ninguna URL) */
(function () {
  'use strict';
  function norm(s) {
    return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
  function slug(s) { return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function evento(nombre, datos) {
    window.dataLayer = window.dataLayer || [];
    var o = { event: nombre }; for (var k in datos) o[k] = datos[k];
    window.dataLayer.push(o);
  }

  function iniciar() {
    var raiz = document.getElementById('velatorios-por-distrito');
    if (!raiz) return;
    var input = raiz.querySelector('[data-mm-dir-buscar]');
    var grupos = Array.prototype.slice.call(raiz.querySelectorAll('[data-mm-dir-grupo]'));
    var estado = raiz.querySelector('[data-mm-dir-estado]');
    var vacio = raiz.querySelector('[data-mm-dir-vacio]');
    var buscando = false, avisado = false;

    function aplicarBusqueda(texto) {
      var q = norm(texto), visibles = 0, totalItems = 0;
      grupos.forEach(function (g) {
        var items = g.querySelectorAll('.mm-dir__item');
        var visiblesGrupo = 0;
        Array.prototype.forEach.call(items, function (it) {
          totalItems++;
          var ok = norm(it.getAttribute('data-nombre')).indexOf(q) !== -1 || norm(it.getAttribute('data-distrito')).indexOf(q) !== -1;
          it.hidden = !ok;
          if (ok) { visiblesGrupo++; visibles++; }
        });
        var conteo = g.querySelector('[data-mm-dir-conteo]');
        if (q) {
          g.hidden = visiblesGrupo === 0;
          if (!g.hidden) g.open = true;
          if (conteo) conteo.textContent = visiblesGrupo + (visiblesGrupo === 1 ? ' coincidencia' : ' coincidencias');
        } else {
          g.hidden = false;
          g.open = false;
          if (conteo) conteo.textContent = items.length + (items.length === 1 ? ' lugar' : ' lugares');
        }
      });
      estado.textContent = q ? ('Mostrando ' + visibles + ' de ' + totalItems) : '';
      vacio.hidden = !q || visibles > 0;
      if (q && visibles === 0 && !avisado) { avisado = true; evento('mm_directorio_sin_resultados', { texto: texto }); }
    }

    var t;
    input.addEventListener('input', function () {
      buscando = !!input.value;
      clearTimeout(t);
      t = setTimeout(function () { aplicarBusqueda(input.value); evento('mm_directorio_buscar', { texto: input.value }); }, 250);
    });

    raiz.addEventListener('click', function (e) {
      var vt = e.target.closest ? e.target.closest('.mm-dir__vertambien a') : null;
      if (vt) {
        e.preventDefault();
        var d = vt.getAttribute('data-mm-dir-distrito');
        var destino = raiz.querySelector('[data-mm-dir-grupo="' + d.replace(/"/g, '\\"') + '"]');
        if (destino) {
          destino.open = true;
          if (destino.scrollIntoView) destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        evento('mm_directorio_distrito', { distrito: d, origen: 'ver_tambien' });
        return;
      }
      var a = e.target.closest ? e.target.closest('.mm-dir__cta, .mm-dir__mapa') : null;
      if (a) {
        var card = a.closest('.mm-dir__item');
        evento('mm_directorio_clic', { lugar: card ? card.getAttribute('data-nombre') : '', accion: a.classList.contains('mm-dir__mapa') ? 'mapa' : 'cta' });
      }
    });

    grupos.forEach(function (g) {
      g.addEventListener('toggle', function () {
        if (g.open) evento('mm_directorio_abrir', { distrito: g.getAttribute('data-mm-dir-grupo') });
      });
    });

    try { var q0 = new URLSearchParams(window.location.search).get('q'); if (q0) { input.value = q0; buscando = true; aplicarBusqueda(q0); } } catch (e) {}
    var hash = (window.location.hash || '').replace('#distrito-', '');
    if (hash) {
      var destino = grupos.filter(function (g) { return slug(g.getAttribute('data-mm-dir-grupo')) === hash; })[0];
      if (destino) { destino.open = true; setTimeout(function () { if (destino.scrollIntoView) destino.scrollIntoView({ block: 'start' }); }, 50); }
    }
  }
  if (document.readyState !== 'loading') iniciar(); else document.addEventListener('DOMContentLoaded', iniciar);
})();
